import { combineReducers } from "redux";

import footerReducer from "../store/footer/reducer";
import headerReducer from "../store/header/reducer";
import searchReducer from "../store/troubleShooting/search/reducer";
import connectint from "../store/connectint/reducer";
import articleDetailReducer from "../store/troubleShooting/articleDetail/reducer";
import authReducer from "../store/auth/reducer";
import nonSubscriberReducer from "../store/nonSubscriber/reducer";


export default combineReducers({
    footerReducer: footerReducer,
    searchReducer: searchReducer,
    articleDetail: articleDetailReducer,
    headerReducer: headerReducer,
    connectint:connectint,
    auth :authReducer,
    nonSubscriber:nonSubscriberReducer
});